module.exports = __webpack_public_path__ + "static/media/img5.0393e27a.jpg";